import React, { Component } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { getApi } from '../App';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';

function normalizeFechaToYMD(fecha) {
  if (!fecha) return '';
  const s = String(fecha).trim();

  // Caso 1: ya comienza con YYYY-MM-DD -> úsalo directo
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  // Caso 2: ISO con offset sin ":" al final (ej. +0000, -0300) -> inserta el ":"
  // 2025-10-17T00:00:00.000+0000 -> 2025-10-17T00:00:00.000+00:00
  const withColonOffset = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

  const d = new Date(withColonOffset);
  if (!isNaN(d)) {
    // normaliza a local y corta YYYY-MM-DD
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  }

  // Último recurso: intenta cortar si detecta patrón adentro
  const m2 = withColonOffset.match(/(\d{4}-\d{2}-\d{2})/);
  return m2 ? m2[1] : '';
}

// Convierte 'YYYY-MM-DD' -> 'YYYY-MM-DDT00:00:00.000±HH:mm' según zona local
function toLocalOffsetISO(dateStr) {
  if (!dateStr) return undefined;
  const offsetMin = -new Date().getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${dateStr}T00:00:00.000${sign}${hh}:${mm}`;
}

export class EditGastosModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
        tipoGastos: [],
        snackbarOpen: false,
        snackbarmsg: '',
        fecha: normalizeFechaToYMD(props.fecha),  
        idExpediente: props.idExpediente,
        tipoGasto: props.tipoGasto ?? 0
    };

  }
  
  componentDidMount() {
    getApi()
      .getTipoGastos()
      .then((data) => this.setState({ tipoGastos: data || [] }));
  }
  

  componentDidUpdate(prevProps) {
    // Cuando cambie el gasto (identificador) o se abra el modal de nuevo
    const openedNow = !prevProps.show && this.props.show;
    const changedItem = prevProps.identificador !== this.props.identificador;

    if (openedNow || changedItem) {
        this.setState({
        fecha: normalizeFechaToYMD(this.props.fecha),
        tipoGasto: this.props.tipoGasto ?? 0,
        idExpediente: this.props.idExpediente
        });
    }
  }


  snackbarClose = () => this.setState({ snackbarOpen: false });

  handleFechaChange = (e) => {
    this.setState({ fecha: e.target.value }); // YYYY-MM-DD
  };

  handleTipoChange = (e) => {
    this.setState({ tipoGasto: e.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const fechaISOConOffset = toLocalOffsetISO(this.state.fecha);

    const data = {
      id: event.target.identificador.value,
      idExpediente: this.props.idExpediente,
      tipoGasto: this.state.tipoGasto,
      fecha: fechaISOConOffset, // o this.state.fecha si backend espera LocalDate
      monto: event.target.monto.value,
      // el name es "nrofactura"
      facturaNroStr: event.target.nrofactura.value,
      proveedor: event.target.proveedor.value,
      resposable: event.target.proveedor.value
    };

    getApi()
      .saveGastos(data)
      .then((res) => res.json())
      .catch((error) => console.error('Error:', error))
      .then((response) => {
        console.log('Success:', response);
        this.setState({ snackbarOpen: true, snackbarmsg: 'El registro se guardó correctamente' });
        this.props.onClose();
      });
  };

  render() {
    const { fecha, tipoGasto, tipoGastos } = this.state;

    return (
      <div className="container">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackbarOpen}
          autoHideDuration={3000}
          onClose={this.snackbarClose}
          message={<span id="message-id">{this.state.snackbarmsg}</span>}
          action={[
            <IconButton key="close" arial-label="Cerrar" color="inherit" onClick={this.snackbarClose}>
              x
            </IconButton>
          ]}
        />
        <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained_modal_title_vcenter">
              Actualizar gastos al expediente {this.props.idExpediente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group controlId="identificador">
                    <Form.Label>Identificador:</Form.Label>
                    <Form.Control
                      type="number"
                      name="identificador"
                      defaultValue={this.props.identificador}
                      required
                      disabled
                      placeholder="Identificador"
                    />
                  </Form.Group>

                  <Form.Group controlId="fechaGasto">
                    <Form.Label>Fecha:</Form.Label>
                    <Form.Control
                      type="date"
                      name="fecha"
                      value={fecha || ''}          
                      onChange={this.handleFechaChange}
                      required
                      placeholder="Fecha del gasto"
                    />
                  </Form.Group>

                  <Form.Group controlId="monto">
                    <Form.Label>Monto:</Form.Label>
                    <Form.Control
                      type="number"
                      name="monto"
                      required
                      defaultValue={this.props.monto}
                      placeholder="Monto del gasto"
                    />
                  </Form.Group>

                  <Form.Group controlId="tipoGasto">
                    <Form.Label>Concepto:</Form.Label>
                    <Form.Control as="select" value={tipoGasto} onChange={this.handleTipoChange}>
                      {tipoGastos.map((tp) => (
                        <option key={tp.identificador} value={tp.identificador}>
                          {tp.Descrip}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="nroFactura">
                    <Form.Label>Nro. de Factura:</Form.Label>
                    <Form.Control
                      type="text"
                      name="nrofactura"
                      maxLength="15"
                      required
                      defaultValue={this.props.facturanrostr}
                      placeholder="Nro. de la Factura"
                    />
                  </Form.Group>

                  <Form.Group controlId="proveedor">
                    <Form.Label>Proveedor:</Form.Label>
                    <Form.Control
                      type="text"
                      name="proveedor"
                      maxLength="30"
                      required
                      defaultValue={this.props.proveedor}
                      placeholder="Proveedor del gasto"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Button variant="primary" type="submit">
                      Grabar
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.props.onHide}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditGastosModal;
